const DOMAIN = 'https://smartbear.my.site.com'
const scrt2URL = 'https://smartbear.my.salesforce-scrt.com'

export class AgentForce {
  static instance: AgentForce
  private instanceCreated = false
  email: string | null = null

  constructor(data: { email: string | null }) {
    this.email = data.email
  }

  static getInstance(data: { email: string | null }): AgentForce {
    if (!AgentForce.instance) {
      AgentForce.instance = new AgentForce(data)
    } else if (data.email !== AgentForce.instance.email) {
      AgentForce.instance.email = data.email
    }
    return AgentForce.instance
  }

  private initEmbeddedMessaging() {
    try {
      window.embeddedservice_bootstrap.settings.language = 'en_US'
      window.embeddedservice_bootstrap.settings.chatButtonPosition = '-1000px,-1000px' // Hide the default chat button initially
      window.embeddedservice_bootstrap.settings.shouldMinimizeWindowOnNewTab = true

      window.embeddedservice_bootstrap.init(
        '00D700000008FQP',
        'Embedded_Deployment_for_Service_Agent',
        `${DOMAIN}/ESWEmbeddedDeploymentfo1739388094135`,
        {
          scrt2URL,
        }
      )

      window.addEventListener('onEmbeddedMessagingReady', () => {
        if (this.email) {
          window.embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields({ Email: this.email })
        }

        window.localStorage.setItem('liveChatScriptLoaded', 'true')
        window.dispatchEvent(new StorageEvent('storage', {
          key: 'liveChatScriptLoaded',
          newValue: 'true',
          oldValue: 'false'
        }))
      })

      // temp event listener until onEmbeddedMessagingWindowClosed is fixed
      window.addEventListener('onEmbeddedMessagingConversationClosed', () => {
        window.localStorage.setItem('liveChatLaunched', 'false')
        window.dispatchEvent(new StorageEvent('storage', {
          key: 'liveChatLaunched',
          newValue: 'false',
          oldValue: 'true'
        }))
      })

      window.addEventListener('onEmbeddedMessagingConversationOpened', () => {
        window.localStorage.setItem('liveChatLaunched', 'true')
        window.dispatchEvent(new StorageEvent('storage', {
          key: 'liveChatLaunched',
          newValue: 'true',
          oldValue: 'false'
        }))
      })

      window.addEventListener('onEmbeddedMessagingWindowMinimized', () => {
        window.localStorage.setItem('liveChatMinimized', 'true')
        window.dispatchEvent(new StorageEvent('storage', {
          key: 'liveChatMinimized',
          newValue: 'true',
          oldValue: 'false'
        }))
      })
      
      window.addEventListener('onEmbeddedMessagingWindowMaximized', () => {
        window.localStorage.setItem('liveChatMinimized', 'false')
        window.dispatchEvent(new StorageEvent('storage', {
          key: 'liveChatMinimized',
          newValue: 'false',
          oldValue: 'true'
        }))
      })

      // this eventListener is not working, known issue and it is the one to be used to detect when the chat window is closed
      // window.addEventListener('onEmbeddedMessagingWindowClosed', () => {
      // })

      this.instanceCreated = true
    } catch (err) {
      console.error('Error loading Embedded Messaging: ', err)
    }
  }

  initAgentForceScript() {
    if (this.instanceCreated) {
      console.warn('AgentForce script already initialized.')
      return
    }

    const script = document.createElement('script')
    script.src = `${DOMAIN}/ESWEmbeddedDeploymentfo1739388094135/assets/js/bootstrap.min.js`
    script.onload = () => this.initEmbeddedMessaging()
    script.onerror = err => console.error('Error loading script:', err)
    document.body.appendChild(script)
  }
}